export function CssCo() {
    const courses = [
      { title: "HTML and CSS in depth (From Meta)", link: "https://www.coursera.org/learn/html-and-css-in-depth" },
      { title: "Introduction to CSS3", link: "https://www.coursera.org/learn/introcss" },
      { title: "Build a Webpage with HTML and CSS", link: "https://www.coursera.org/learn/build-a-webpage-with-html-and-css" },
      { title: "Learn Tailwind CSS", link: "https://coursera.org/learn/learn-tailwind-css" },
      { title: "Tailwind CSS Specialization", link: "https://www.coursera.org/specializations/tailwind-css" },
    ];
  
    return (
      <>
        <h1 className="html_co_heading">
          These are the <strong style={{ textDecoration: "underline", color: "blue" }}>Top 5</strong> recommended Coursera courses with certifications
        </h1>
  
        <h4 className="des_co_html">
          1. Dive Into The Main Concepts <br />
          2. Animation Explanations with real-world Examples <br />
          3. Important Note Clarifications
        </h4>
  
        {/* Course List */}
        {courses.map((course, index) => (
          <div className="container_html_co_links" key={index}>
            <p className="vid">{index + 1}. {course.title}</p>
            <button
              style={{
                marginLeft: "200px",
                padding: "7px",
                background: "black",
                color: "white",
                borderRadius: "8px",
              }}
              onClick={() => window.open(course.link, "_blank")}
            >
              Click Me
            </button>
          </div>
        ))}
      </>
    );
  }
  
  export default CssCo;
  